import React, { useMemo } from 'react';

import cs from 'classnames';

import { ComponentParamsProvider } from 'lib/context/ComponentParamsContext/ComponentParamsProvider';

import AGBasicTable from 'components/shared/AGBasicTable/AGBasicTable';
import Button from 'components/shared/Buttons/Button';
import Modal from 'components/shared/Modal/Modal';

import { DEFAULT_COL_DEFS, colDefs } from '../lib/otherAdjustmentsConfig';

const OtherAdjustmentsModal = ({ isOpen, handleClose, formik, onClose }) => {
  const rowData = useMemo(() => formik.values.procedures || [], [formik.values.procedures]);

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Other Adjustments"
      bodyClassName="p-0"
      className={cs(
        '!h-[calc(100vh-350px)] !w-[calc(100vw-350px)] bg-primary-10 sm:!h-full sm:!w-full'
      )}
      footer={
        <div className={cs('flex w-full justify-between ')}>
          <Button
            outlined
            text="Close"
            color="neutral"
            onClick={onClose}
            id="closeServiceModalBtn"
          />
          <Button
            onClick={() => formik.submitForm()}
            text="Update Other Adjustments"
            id="update-other-adjustments-btn"
            data-qa="update-other-adjustments-btn"
            loading={formik.isSubmitting}
            disabled={formik.isSubmitting}
          />
        </div>
      }>
      <ComponentParamsProvider formik={formik}>
        <AGBasicTable
          rowData={rowData}
          columnDefs={colDefs}
          customClassName="ag-grid-interactive"
          defaultColDef={DEFAULT_COL_DEFS}
        />
      </ComponentParamsProvider>
    </Modal>
  );
};

export default OtherAdjustmentsModal;
